

import { TableBody, TableCell } from '@material-ui/core'
import React, { useEffect } from 'react'
import { useLead } from '../../../hooks/Features/useLeads'
import { itemsPerPage } from '../../../shared/data'
import CustomPagination from '../../CustomPagination'
import Layout from '../../Layout'
import Loader from '../../Loader'
import CustomTable from '../../Table/CustomTable'
import CustomTableHeading from '../../Table/CustomTableHeading'
import CustomTableRow from '../../Table/CustomTableRow'
import styles from '../reports.module.css'
import { NoDataFound } from '../../NoDataFound'
import { SortIcon, FilterIcon } from '../../CustomComponents/CustomFilterIcon'

export default function ProductCategoryDetailedReportMTD() {
  const { loading, getProductCategoryDetailedReportMTD, lead } = useLead()
  const [page, setPage] = React.useState(1)
  const startDate = new Date()
  startDate.setDate(1)
  startDate.setHours(0, 0, 0)
  const [from, setFrom] = React.useState(startDate)
  const [to, setTo] = React.useState(new Date())

  useEffect(() => {
    setPage(1)
    getProductCategoryDetailedReportMTD({ from: from, to: to })
  }, [from, to])

  const noOfPages = Math.ceil(lead && lead.length / itemsPerPage)
  const handleChange = (event, value) => {
    setPage(value)
  }

  const heading = [
    { label: 'Category', key: 'category' },
    { label: 'Sub-Category', key: 'subCategory' },
    { label: 'SKU', key: 'sku' },
    { label: 'Product Name', key: 'productName' },
    { label: 'Qty', key: 'qty' },
    { label: 'Value', key: 'value' },
  ]

  let tempLead = []
  lead &&
    lead.forEach((item) =>
      tempLead.push({
        category:item.category,
        subCategory: item.subCategory,
        sku:item.sku,
        productName:item.name,
        qty: item.quantity,
        value:item.value
      })
    )

  return (
    <Layout
      heading="Product Category Detailed Report MTD"
      none
      selectedFrom={from}
      setSelectedFrom={setFrom}
      selectedTo={to}
      setSelectedTo={setTo}
      headers={heading}
      data={tempLead ? tempLead : []}
      tempHeaderData={[]}
      filename='product_category_detailed_report_mtd'
    >
      <CustomTable padding className={styles.table}>
        <CustomTableHeading heading={['CATEGORY', 'SUB-CATEGORY', 'SKU', 'PRODUCT NAME', 'QTY', 'VALUE']} />
        <TableBody className={styles.tr}>
          {!loading &&
            lead.length > 0 &&
            lead.slice((page - 1) * itemsPerPage, page * itemsPerPage).map((item, index) => {
              return (
                <CustomTableRow>
                  <TableCell> {item.category} </TableCell>
                  <TableCell> {item.subCategory} </TableCell>
                  <TableCell> {item.sku} </TableCell>
                  <TableCell> {item.name} </TableCell>
                  <TableCell> {item.quantity} </TableCell>
                  <TableCell> {item.value} </TableCell>
                </CustomTableRow>
              )
            })}
        </TableBody>
      </CustomTable>
      {loading && <Loader />}
      {!loading && lead.length > 0 && (
        <CustomPagination noOfPages={noOfPages} page={page} handleChange={handleChange} />
      )}

      {!loading && lead.length === 0 && <NoDataFound />}
    </Layout>
  )
}
